import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import "../../../Menu.css";
import { checkMenuActive, getSectionName, isSectionActive, isAnyDescendantActive } from "../../../../../Utils/utils";
import {MAX_NOTIFICATIONS, DISPLAY_NOTIFICATIONS, ACTIVE_CLASS, URL_PATH_NOTIFICATIONS } from "../../../../../Utils/Constants";
import { MULTITENANT_CONSTANTS, TENANT } from "../../../../../Resources/Multitenant/tenantConstants";

const LateralMenuItem = ({ section, changeSection, getIconSection, location, sectionSelected, sections, depth }) => {
  const [expanded, setExpanded] = useState(false);
  const hasChildren = section.children?.length > 0;

  if (hasChildren) {
    return (
      <div>
        <div
          className={`MenuSectionRes ${section.section.iconId} ${(isSectionActive(section, location.pathname) || isAnyDescendantActive(section, location.pathname)) ? ACTIVE_CLASS : ""}`}
          onClick={() => setExpanded(!expanded)}
        >
          {getIconSection(section.section?.iconsvg || section.section.iconId, section.section)}
          <span className="TextRes">{getSectionName(section.section)}</span>
          <ion-icon
            name={expanded ? "chevron-up-outline" : "chevron-down-outline"}
            className="LateralMenuChevron"
            aria-hidden="true"
          />
        </div>
        {expanded && (
          <div className={`LateralSubmenuContainer LateralSubmenuContainer--depth-${depth}`}>
            {section.children.map((child, index) => (
              <LateralMenuItem
                key={child.section.name + "-" + index}
                section={child}
                changeSection={changeSection}
                getIconSection={getIconSection}
                location={location}
                sectionSelected={sectionSelected}
                sections={sections}
                depth={depth + 1}
              />
            ))}
          </div>
        )}
      </div>
    );
  }

  return (
    <div>
      <NavLink
        to={{ pathname: section.url, aboutProps: { dinamic: section.section.screenId } }}
        onClick={() => changeSection(section.section)}
        className={`MenuSectionRes ${section.section.iconId} ${isSectionActive(section, location.pathname) ? ACTIVE_CLASS : ""}`}
        isActive={(match, loc) => checkMenuActive(match, loc, section, sectionSelected, sections, sections)}
      >
        {getIconSection(section.section?.iconsvg || section.section.iconId, section.section)}
        <span className="TextRes">{getSectionName(section.section)}</span>
      </NavLink>
    </div>
  );
};

const LateralMenu = ({
  onContainerClick,
  displayMenu,
  sections,
  changeSection,
  studioSection,
  configurationSection,
  logOutSection,
  logout,
  handleToggleNotificationMenu,
  notifications,
  getIconSection,
  configurationIcon,
  logoutIcon,
  reloadIconFlag,
}) => {
  const { t } = useTranslation();
  const location = useLocation();

  const userData = useSelector((state) => state.commonState.userData);
  const userLogin = useSelector((state) => state.commonState.userLogin);
  const sectionSelected = useSelector((state) => state.commonState.sectionSelected);
  const profileMenuVisible = useSelector((state) => state.commonState.profileMenuVisible);

  useEffect(() => { }, [reloadIconFlag]);

  const handleRedirectToStudio = () => {
    window.open(studioSection.url, "_blank");
  };
  const unreadNotifications = notifications?.filter((notification) => notification.isNew).length || 0;
  const notificationDisplay = unreadNotifications > MAX_NOTIFICATIONS? DISPLAY_NOTIFICATIONS : unreadNotifications;

  return (
    <div className="MenuLateralResContainer" onClick={onContainerClick}>
      <div className="MenuLateralRes ">
        <div className={"MenuSection"}>
          <div className={"PecharMenu"} onClick={displayMenu}>
            <ion-icon name="close" aria-label={t("menu.close")} />
          </div>
        </div>
        <div className={"MenuContainer"}>
          <div>
            {sections?.map((section, index) => (
              <LateralMenuItem
                key={section.section.name + "-" + index}
                section={section}
                changeSection={changeSection}
                getIconSection={getIconSection}
                location={location}
                sectionSelected={sectionSelected}
                sections={sections}
                depth={0}
              />
            ))}
          </div>
          <div className="MenuInferiorIcons">
          {MULTITENANT_CONSTANTS[TENANT]?.showNotifications  && !!userData.username && (
            <div
              className={`MenuSectionRes notifications-section ${location.pathname === URL_PATH_NOTIFICATIONS ? ACTIVE_CLASS : ""
                }`}
              onClick={handleToggleNotificationMenu}
            >
              <div className="NotificationBellWrapper">
                <ion-icon name="notifications" className="NotificationBell" aria-label={t("notifications")} />
                {unreadNotifications > 0 && (
                  <div className="NotificationDoto">{notificationDisplay}</div>
                )}
              </div>
              <span className="TextRes">{t("notifications")}</span>
                  </div>
              )}
            {studioSection.url && (!!userData.username || !!userLogin) && (
                  <div onClick={handleRedirectToStudio}>
                    <p className={"MenuSectionRes " + studioSection.section.iconId}>
                      <ion-icon name={studioSection.section.iconId} aria-label={t(studioSection.section.name)}/>
                      <span className="TextRes">{t(studioSection.section.name)}</span>
                    </p>
                  </div>
              )}
            {profileMenuVisible && configurationSection && (!!userData.username || !!userLogin) && (
                   <NavLink
                   to={{ pathname: configurationSection.url.toLowerCase() }}
                   onClick={() => changeSection(configurationSection.section)}
                   className="MenuSectionRes configuration-icon"
                   key={configurationSection.section.iconId}
                 >
                   {configurationIcon}
                   <span className="TextRes">{t(configurationSection.section.name)}</span>
                 </NavLink>
               )}
            {profileMenuVisible && logOutSection && (!!userData.username || !!userLogin) && (
              <div onClick={logout} className="MenuSectionRes logout-icon">
                {logoutIcon}
                <span className="TextRes">{t(logOutSection.section.name)}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LateralMenu;
